import axios from 'axios';
import store from "../store";
const PREFIJO="/api/Prv/";

export default {
    provincias(nombre) {
        const dto={
            dt1:nombre,
        };
        return axios.post(`${PREFIJO}VmSlPrv`,dto);
    }
};
